document.addEventListener("DOMContentLoaded", () => {
  // if (window.countryPopupLoaded) return;
  // window.countryPopupLoaded = true;

  const togglePopup = (popup, open) => {
    if (open) {
      popup.classList.add("active");
      setTimeout(() => {
        popup.classList.add("open");
      }, 50);
    } else {
      popup.classList.remove("open");
      setTimeout(() => {
        popup.classList.remove("active");
      }, 300);
    }
  };

  const btnRestrictions = document.querySelectorAll(".section-image-lp .country-restriction-btn");
  if (!btnRestrictions[0]) {
    return;
  }
  btnRestrictions.forEach((btn) => {
    if (document.body.classList.contains("rest-of-the-world-us-market")) {
      console.log("test")
      btn.removeAttribute("data-variant-id");
      const popup = btn.parentElement.querySelector(".country-restriction-popup");
      if (!popup) return;
      const closePopup = popup.querySelector(".country-restriction-popup__close");
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        console.log("test")
        togglePopup(popup, true);
      });
      closePopup.addEventListener("click", () => togglePopup(popup, false));
      popup.addEventListener("click", (e) => {
        if (e.target.classList.contains("country-restriction-popup__overlay")) {
          togglePopup(popup, false);
        }
      });
    }
  });
});